/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAttributeDataSourceByKeyPathParams = NonNullable<
  operations['getAttributeDataSourceByKey']['parameters']['path']
>;

export interface Input extends GetAttributeDataSourceByKeyPathParams {
  apiVersion?: string;
}

export async function getAttributeDataSourceByKey(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/attribute-data-sources/{dataSourceKey}', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
